/* Avena – Sie-Ansprache und deutsche Standardtexte für die wenigen Dawn-Texte */
(function(){
  var MAP = [
    ['Dein Warenkorb ist leer', 'Ihr Warenkorb ist leer'],
    ['Dein Warenkorb', 'Ihr Warenkorb'],
    ['Wenn du dich für eine Auswahl entscheidest, wird die Seite komplett aktualisiert', 'Wenn Sie eine Auswahl treffen, wird die Seite vollständig aktualisiert'],
    ['Hast du ein Konto?', 'Haben Sie ein Konto?'],
    ['Melde dich an, damit es beim Checkout schneller geht.', 'Melden Sie sich an, damit es beim Checkout schneller geht.'],
    ['Melde dich an', 'Melden Sie sich an'],
    ['Gib deine E-Mail-Adresse ein', 'Ihre E-Mail-Adresse'],
    ['Deine E-Mail', 'Ihre E-Mail'],
    ['Danke für deine Anmeldung', 'Vielen Dank für Ihre Anmeldung'],
    ['Sieh dir', 'Sehen Sie sich'],
    ['Rabatte und Versand werden beim Checkout berechnet', 'Mengenrabatt wird automatisch abgezogen, der Versand ist kostenlos'],
    ['Inkl. Steuern.', 'inkl. MwSt.'],
    ['Inkl. Steuern', 'inkl. MwSt.']
  ];
  var RX = /[dD](u|ein|ich|ir)\b|[dD]ein|Hast|Melde|Gib|Sieh|Steuern|Rabatte/;
  function fix(root){
    if (!root) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), n, s;
    while ((n = w.nextNode())){
      s = n.nodeValue; if (!s || s.length > 400 || !RX.test(s)) continue;
      for (var i = 0; i < MAP.length; i++){ if (s.indexOf(MAP[i][0]) > -1){ s = s.split(MAP[i][0]).join(MAP[i][1]); } }
      if (s !== n.nodeValue) n.nodeValue = s;
    }
    var els = root.querySelectorAll ? root.querySelectorAll('[aria-label],[placeholder],[title]') : [];
    for (var j = 0; j < els.length; j++){
      ['aria-label','placeholder','title'].forEach(function(a){ var v = els[j].getAttribute(a); if (!v) return; var o = v; MAP.forEach(function(m){ if (v.indexOf(m[0]) > -1) v = v.split(m[0]).join(m[1]); }); if (v !== o) els[j].setAttribute(a, v); });
    }
  }
  function run(){ fix(document.body); }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
  if ('MutationObserver' in window){
    new MutationObserver(function(ms){ ms.forEach(function(m){ m.addedNodes && m.addedNodes.forEach(function(nd){ if (nd.nodeType === 1) fix(nd); else if (nd.nodeType === 3 && nd.parentNode) fix(nd.parentNode); }); }); })
      .observe(document.documentElement, { childList:true, subtree:true });
  }
})();
